import i18n from '@/legacy/i18n';
import { eagerResources } from './resources';

/**
 * Additive runtime wiring for the namespaced i18n layout.
 *
 * This does NOT touch the legacy init in `@/legacy/i18n` — the legacy `translation`
 * bundle keeps resolving every existing `t('legacyKey')` call. We only register the
 * new per-namespace resources alongside it, so new code can use `t('ns:key')`.
 *
 * All namespaces are registered eagerly: total copy is ~34KB gzipped per language, so
 * lazy loading is not worth its dev cost. The namespace structure is preserved, so a
 * single heavy namespace can be made lazy later without restructuring (see DECISIONS.md).
 */
for (const lng of Object.keys(eagerResources) as (keyof typeof eagerResources)[]) {
	const bundles = eagerResources[lng];
	for (const ns of Object.keys(bundles) as (keyof typeof bundles)[]) {
		if (!i18n.hasResourceBundle(lng, ns)) {
			i18n.addResourceBundle(lng, ns, bundles[ns], true, true);
		}
	}
}
